import {
	PageNotFound,
	PageSkeleton,
	PaymentStatus,
} from '@paylink/components/composed';
import { usePayLinkInit } from '@paylink/hooks';
import { DesktopLayout, MobileLayout } from '@paylink/container';
import { PaylinkState } from '@paylink/types';

import { useIsMobile } from '@shared/hooks/useIsMobile';

const App = () => {
	const isMobile = useIsMobile();

	const {
		isLoading,
		hasError,
		phone,
		phoneError,
		phoneNumberRequired,
		paylinkDetail,
		isPaylinkVerifying,
		handlePhoneInput,
		handleVerifyPhone,
		handleProceed,
		handleKeyDown,
	} = usePayLinkInit();

	const paylinkState = paylinkDetail?.state || '';

	if (isLoading) return <PageSkeleton />;
	if (hasError) return <PageNotFound />;

	const commonProps = {
		merchantName: paylinkDetail.merchantName ?? '',
		logoId: paylinkDetail.merchantId ?? '',
		amount: paylinkDetail.amount ?? 0,
		description: paylinkDetail.description ?? '',
		subscriptionDetails: paylinkDetail?.subscriptionDetails,
		orderId: paylinkDetail.orderId ?? '',
		expireAt: paylinkDetail.expireAt,
		phone,
		phoneError,
		phoneNumberRequired,
		isPaylinkVerifying,
		paylinkState,
		handlePhoneInput,
		handleVerifyPhone,
		handleProceed,
		handleKeyDown,
	};

	if (
		paylinkState === PaylinkState.ERRORED ||
		paylinkState === PaylinkState.FAILED
	) {
		return <PaymentStatus state={paylinkState} />;
	}

	return isMobile ? (
		<MobileLayout {...commonProps} />
	) : (
		<DesktopLayout {...commonProps} />
	);
};

export default App;
